import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=0a8157dc&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8157dc')) {
      api.createRecord('0a8157dc', component.options)
    } else {
      api.reload('0a8157dc', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=0a8157dc&", function () {
      api.rerender('0a8157dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/CategoryItem.vue"
export default component.exports